import * as S from './styles'
import React from "react";

export enum Variant {
    Default,
    Business,
    Outline_Business
}

interface Props {
    children?: JSX.Element | JSX.Element[] | String | undefined,
    onClick?: React.MouseEventHandler<HTMLElement>,
    disabled?: boolean,
    variant?: Variant
}

export const Button = ({children, onClick, disabled = false, variant = Variant.Default}: Props) => (
    <S.Button onClick={onClick} disabled={disabled} variant={variant}>{children}</S.Button>
);